import { useContext } from "react"
import { PipelineBulkActionsContext } from "../components/PipelineBulkActions"

export default function usePipelineBulkActions() {
  return useContext(PipelineBulkActionsContext)
}
